export const WEBVIEW_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;
export const MOBILE_BREAKPOINT = 768;

export function checkIsWebView(): boolean {
  return window.innerWidth > WEBVIEW_BREAKPOINT;
}

export function checkIsTabletView(): boolean {
  return window.innerWidth <= TABLET_BREAKPOINT && window.innerWidth > MOBILE_BREAKPOINT;
}
